var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('a',{staticClass:"el-button el-button--info el-button--small skip-to-content",attrs:{"href":"#main-element"}},[_vm._v(" Skip to content ")]),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }